import React, { useState, useEffect } from 'react';
import '../css/Testimonials.scss';
import { FaQuoteLeft } from 'react-icons/fa6';

const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const delay = 10000; // 


  const testimonials = [
    {
      text: "HoneyRock has proved to me that there is still hope in the Nigerian Academic circle. A school centered and focused on the fear of God can never go wrong. It is visible in the lives of our children only just a few months from joining HoneyRock! We have found a home.",
      name: "Frranca Peters Agboola",
      job: "Parent",
    },
    {
      text: "Your daughter won the spelling bee competition in the whole Province of Nova Scotia 🙂 Out of 127 contestants she came 1st. Thank you to The HoneyRock School for the impact and foundation 🤗🙏🥰",
      name: "Mrs Njoku",
      job: "Parent",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) =>
        prevIndex === Math.ceil(testimonials.length / 3) - 1 ? 0 : prevIndex + 1
      );
    }, delay);

    return () => clearInterval(interval); 
  }, [index, testimonials.length]);

  return (
    <div className="testimonial-section page-width">
      <header className="testimonial-section-header">Testimonials</header>
      <div className="testimonial-container">
      
          {testimonials.map((testimonial, idx) => (
            <div className="testimonial autoShow" key={idx}>
              <FaQuoteLeft/>
              <div className="parent-info">
                <div className="parent-details">
                  <p className="parent-name">{testimonial.name}</p>
                </div>
              </div>
              <p className="parent-feedback">{testimonial.text}</p>
            </div>
          ))}
      
      </div>
    </div>
  );
};

export default Testimonials;
